import React from 'react'
import useLangTranslation from "../../../customHooks/languageProvider";
// import { isEmpty } from 'lodash';
import { Modal } from 'react-bootstrap';
import LoadingIndicator from '../../../../setup/Loader/LoaderIndicator';
// import { constant } from '../../../../utils/constant';

const AddNewApp = ({
    showModal,
    closeModal,
    allAppData,
    setAppId,
    appId,
    handleContinueBtn,
    error = '',
    loader = false,
    heading = "ADD_NEW_APP",
    headingVal = "Add a new app",
    setSocialMediaData,
    setPageNumber
}) => {
    const { getLangTranslation } = useLangTranslation();

    function handleInputChange(e) {
        setAppId(e.target.id);
    }

    return (
        <>
            <Modal
                show={showModal}
                size="sm"
                className="custom-modal blur-bg"
                centered
            >
                <Modal.Header>
                    <div className="border-0 pb-0 d-flex justify-content-between w-100">
                        <h6 className="modal-title text-blue-900">{getLangTranslation(heading, headingVal)}</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
                    </div>
                </Modal.Header>
                <Modal.Body className='py-3 px-4'>
                    <>
                        {
                            allAppData?.length > 0 ? (
                                <>
                                    <div className="overflow-auto" style={{ height: '420px' }}>
                                        {
                                            error && (
                                                <div className='my-2'>
                                                    <span className='text-danger fs-8'>{getLangTranslation(error)}</span>
                                                </div>
                                            )
                                        }
                                        <ul
                                            className='list-unstyled border rounded-3'
                                        >
                                            {
                                                allAppData?.map((item, index) => {
                                                    return (
                                                        <li className={index === 0 ? 'p-2 ps-6 bg-gray-300' : 'border-top p-2 ps-6'}>
                                                            <div className="form-check mb-0">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="flexRadioDefault"
                                                                    id={item?.ID}
                                                                    checked={parseInt(item?.ID) === parseInt(appId)}
                                                                    onChange={(e) => handleInputChange(e)}
                                                                />
                                                                <label
                                                                    className="form-check-label d-inline-flex align-items-center text-dark"
                                                                    htmlFor={item?.ID}
                                                                >
                                                                    <span className="icon-wrap icon-sm me-2 p-0 border-0">
                                                                        <img src={item?.image} alt='' />
                                                                    </span>
                                                                    {item?.app_name}
                                                                </label>
                                                            </div>
                                                        </li>
                                                    )
                                                }
                                                )
                                            }
                                        </ul>
                                    </div>
                                    <div className="grid gap-3 my-4">
                                        <button
                                            className="btn btn-primary g-col-6"
                                            type="button"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                                setSocialMediaData([]);
                                                setPageNumber(1);
                                                setTimeout(() => {
                                                    handleContinueBtn();
                                                }, 1000)
                                            }}
                                        >
                                            {
                                                loader ? (
                                                    <LoadingIndicator width={100} height={20} />
                                                ) : (
                                                    <span className="btn-upper-case">{getLangTranslation("CONTINUE", "Continue")}</span>
                                                )
                                            }
                                        </button>
                                        <button
                                            className="btn btn-outline-primary g-col-6"
                                            type="button"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => {
                                                setAppId("")
                                            }}
                                        >
                                            <span className="btn-upper-case">{getLangTranslation("CLEAR", "Clear")}</span>
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <div className='text-center my-3'>
                                    --- {getLangTranslation("NO_DATA_LOG", "No Data Found")} ---
                                </div>
                            )
                        }

                    </>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default AddNewApp